import React from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { connect } from 'react-redux';
import { setContenu } from '../redux/actions'
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';

function LegendeCouche({ id, item, itemImg, listecontenu, setContenu }) {

    const changerAffichage = (e) => {
        e.preventDefault();
        e.stopPropagation();

        var listecontenu_new = listecontenu;
        listecontenu_new[id].afficher = !item.afficher;
        setContenu(listecontenu_new);
    }

    return <div key={id} className="entete_block entete_popup" onClick={changerAffichage}>
        <img src={itemImg} className="entete_picto" alt={item.titre} />

        {
            item.integrer ?
                !item.afficher ?
                    <Tooltip title="afficher les points" disableInteractive arrow>
                        <IconButton>
                            <VisibilityIcon className="css-vubbuv" />
                        </IconButton>
                    </Tooltip>
                    :
                    <Tooltip title="Masquer les points" disableInteractive arrow>
                        <IconButton>
                            <VisibilityOffIcon className="css-vubbuv" />
                        </IconButton>
                    </Tooltip>
                :
                null

        }


        <div className="entete_block_texte">
            <div className="entete_titre">{item.titre}</div>
            {
                item.soustitre.length > 1 ?
                    <div className="entete_soustitre">{item.soustitre}</div>
                    :
                    null
            }
        </div>
    </div>
}


function mapStateToProps(state) {
    return {
        listecontenu: state.contenu
    }
}

export default connect(mapStateToProps, { setContenu })(LegendeCouche);